import { render, staticRenderFns } from "./PrivilegeDetailPanel.vue?vue&type=template&id=6e19f086&scoped=true"
import script from "./PrivilegeDetailPanel.vue?vue&type=script&lang=js"
export * from "./PrivilegeDetailPanel.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeDetailPanel.vue?vue&type=style&index=0&id=6e19f086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19f086",
  null
  
)

export default component.exports